<template>
  <v-menu v-model="dateMenu" :close-on-content-click="false" transition="scale-transition" offset-y :nudge-top="hideDetails?0:24">
    <template v-slot:activator="{ on }">
      <v-text-field :label="label ? label : 'Date range'" dense :outlined="outlined" readonly v-on="on" v-model="dateDisplay" class="text-body-2 cursor-pointer"
                    append-icon="mdi-menu-down" @click:append="dateMenu=true" :hide-details="hideDetails" :disabled="disabled"/>
    </template>
    <v-card>
      <v-container class="pa-0">
        <v-row no-gutters>
          <v-col style="height:290px;border-right:thin solid #ddd">
            <v-list class="text-caption overflow-y" :height="allowAll ? 256 : 290">
            <template v-for="(option,index) in calendarOptions">
              <v-list-item v-if="option.text" :key="index" class="px-8" dense @click="selectOption(index)">{{option.text}}</v-list-item>
              <v-divider v-else/>
            </template>
            </v-list>
            <v-switch v-if="allowAll"
                      dense class="pl-1 pt-1 mt-0" style="border-top: thin solid #ddd" hide-details
                      v-model="globalDate">
              <template v-slot:label><span class="text-caption">Use globally</span></template>
            </v-switch>
          </v-col>
          <v-col>
            <v-date-picker v-model="dateRange" no-title range @change="change" @click:date="notAllAnyMore"/>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-menu>

</template>

<script>
import {format,startOfWeek,endOfWeek,startOfMonth,lastDayOfMonth,startOfQuarter,lastDayOfQuarter,startOfYear,lastDayOfYear,add} from 'date-fns'

export default {
  name: 'DateRange',
	props: {
		value: {type:String,required:false},
		from: {type:String,required:false},
    to: {type:String,required:false},
		label: {type:String,required:false},
    outlined: {type:Boolean,required:false,default:true},
    hideDetails: {type:Boolean,required:false,default:false},
    option: {type:String,required:false,default:'Last 30 days'},
    disabled: {type:Boolean,required:false,default:false},
    allowAll: {type:Boolean,required:false,default:false}
  },
  data() {
    return {
      dateMenu: false,
      dateRange: [this.from, this.to],
      today: format(new Date(), 'yyyy-MM-dd'),
      calendarOptions: [],
      all: false
    }
  },
  computed: {
    globalDate: {
      get() {
        return this.$store.state.globalDate;
      },
      set(newValue) {
        this.$store.commit('setGlobalDate', newValue);
        this.change();
      }
    },
    dateDisplay() {
      if (this.all)
        return 'All dates';
      if (this.dateRange.length != 2)
        return '';
      const dateFormat = this.$store.getters.company.settings.dateFormat;
      const dpFrom = this.dateRange[0].split('-');
      const dpTo = this.dateRange[1].split('-');
      return `${format(new Date(dpFrom[0],dpFrom[1]-1,dpFrom[2]),dateFormat)} to ${format(new Date(dpTo[0],dpTo[1]-1,dpTo[2]),dateFormat)}`;
    }
  },
  watch: {
    option() {
      const calendarOption = this.calendarOptions.findIndex(o => o.text === this.option);
      if (calendarOption !== -1)
        this.selectOption(calendarOption);
    },
    from() {
      if (!this.from)
        this.all = true;
    }
  },
  created() {
    const today = new Date();
    this.calendarOptions = [
        {text:'Last 30 days', set:() => {return [add(today,{days:-29}),today]}},
        {text:'Last 60 days', set:() => {return [add(today,{days:-59}),today]}},
        {text:'Last 90 days', set:() => {return [add(today,{days:-89}),today]}},
        {text:'Last 365 days', set:() => {return [add(today,{days:-364}),today]}},
        {divider:true},
        {text:'This week', set:() => {return [startOfWeek(today),endOfWeek(today)]}},
        {text:'This month', set:() => {return [startOfMonth(today),lastDayOfMonth(today)]}},
        {text:'This quarter', set:() => {return [startOfQuarter(today),lastDayOfQuarter(today)]}},
        {text:'This year', set:() => {return [startOfYear(today),lastDayOfYear(today)]}},
        {divider:true},
        {text:'Last week', set:() => {return [add(startOfWeek(today),{days:-7}),add(endOfWeek(today),{days:-7})]}},
        {text:'Last month', set:() => {return [add(startOfMonth(today),{months:-1}),lastDayOfMonth(add(startOfMonth(today),{months:-1}))]}},
        {text:'Last quarter', set:() => {return [add(startOfQuarter(today),{months:-3}),lastDayOfQuarter(add(startOfQuarter(today),{months:-3}))]}},
        {text:'Last year', set:() => {return [add(startOfYear(today),{years:-1}),lastDayOfYear(add(startOfYear(today),{years:-1}))]}},
        {divider:true},
        {text:'Today', set:() => {return [today,today]}},
        {text:'Yesterday', set:() => {return [add(today,{days:-1}),add(today,{days:-1})]}}
      ];
    if (this.allowAll)
      this.calendarOptions.splice(0, 0, {text:'All'}, {divider:true});

    if (this.globalDate) {
      this.dateRange[0] = this.$store.state.globalDateRange[0];
      this.dateRange[1] = this.$store.state.globalDateRange[1];
    }
    if (this.dateRange[0] && this.dateRange[1])
      this.change();
    else {
      const calendarOption = this.calendarOptions.findIndex(o => o.text === this.option);
      if (calendarOption !== -1)
        this.selectOption(calendarOption);
    }
  },
  methods: {
    notAllAnyMore() {
      this.all = false;
    },
    reset() {
      this.selectOption(0);
    },
    selectOption(selected) {
      if (this.calendarOptions[selected].text === 'All') {
        this.dateRange = [this.today, this.today];
        this.all = true;
      }
      else {
        this.all = false;
        let newDate;
        newDate = this.calendarOptions[selected].set();
        this.dateRange = [format(newDate[0],'yyyy-MM-dd'),format(newDate[1],'yyyy-MM-dd')];
      }
      this.$emit('update:option', this.calendarOptions[selected].text);
      this.change();
    },
		change() {
      this.dateMenu = false;
      this.$emit('update:from', this.all ? null : this.dateRange[0]);
      this.$emit('update:to', this.all ? null : this.dateRange[1]);
			this.$emit('input',this.dateDisplay);
      this.$emit('change',this.dateDisplay);
      if (this.globalDate)
        this.$store.commit('setGlobalDateRange', this.all ? [null,null] : this.dateRange);
    }
  }
}
</script>